import {Component, Input} from '@angular/core';
import {TabSwitcherConfig} from './tab-switcher-configuration.interface';
import {TranslatePipe} from '@ngx-translate/core';
import {RouterLink, RouterLinkActive} from '@angular/router';

@Component({
  selector: 'app-tab-switcher',
  imports: [
    TranslatePipe,
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './tab-switcher.component.html',
  standalone: true
})
export class TabSwitcherComponent {
  @Input() public config: TabSwitcherConfig[] = [];
}
